export default "<div class=\"nothingButEcho\"><i class=\"fas fa-assistive-listening-systems\"></i> Nothing but echo...</div>";